export const DISPUTE = 'DISPUTE';
export const DISPUTE_ALL = `${DISPUTE}/ALL`;
export const DISPUTE_BY_ID = `${DISPUTE}/BY_ID`;
export const DISPUTE_SEARCH = `${DISPUTE}/SEARCH`;
export const DISPUTE_EXPORT = `${DISPUTE}/EXPORT`;
export const DISPUTE_REASONS = `${DISPUTE}/REASONS`;
export const DISPUTE_STRIPE = `${DISPUTE}/STRIPE`;
